// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"Arrow__2pUmA","Button":"Button__3ekdB"};